import React, { useEffect, useState } from 'react';

import styles from './CartOrder.module.css'
import { Button } from "../../../../ui/General/Button/Button.tsx";
import { Order } from "../../../../types/Order.interface.ts";
import { Address, DeliveryType } from "../../../../types/Delivery.interface.ts";
import { Loader } from "../../../../ui/Loader/Loader.tsx";
import { Checkbox } from '../../../../ui/Filters/components/Checkbox/Checkbox.tsx';
import { useNavigate } from "react-router-dom";
import { cn } from '../../../../utils/cn.ts';
// import { useMultiStorage } from '../../../../hooks/useStorage.ts';
import { API_URL } from '../../../../config.tsx';
import { RootState, useAppDispatch, useAppSelector } from '@/utils/storage/stores/store.ts';
import { setIsShowLoginAndSignInPopup } from '@/utils/storage/slices/userSlice.ts';

interface Props {
    isAuth: boolean,
    createOrder: (withBonuses: boolean) => Promise<Response>,
    setIsOpenChangeTownModal: (isOpenChangeTownModal: boolean) => void,
    onDeliveryAddressChange: (address: Address, isUpdate: boolean, changeBranch: boolean, deliveryType: string | null) => void,
}

export const CartOrder: React.FC<Props> = ({ createOrder, setIsOpenChangeTownModal, isAuth }) => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [withBonuses, setWithBonuses] = useState<boolean>(false);
    const [bonusDiscount, setBonusDiscount] = useState<number>(0);
    const [offer, setOffer] = useState<Order | null>(null);
    const cartOffer = useAppSelector((state: RootState) => state.cart.cartOffer);
    // const [_, setStorage] = useMultiStorage({
    //     showLoginAndSignInPopup: ['showLoginAndSignInPopup', false],
    //     cartOffer: ['cartOffer', offer],
    //   });
    const bonusBalance = useAppSelector((state: RootState) => state.user.userInfo?.bonusBalance || 0);

    const getBonusDiscount = (cartId: number) => {
        fetch(`${API_URL}/cart/${cartId}/discount_by_bonuses`)
            .then(response => response.json())
            .then(response => setBonusDiscount(response.discount !== 0 ? Math.abs(response.discount) / 100 : 0));
    }

    const receiveCreateOrder = () => {
        if (isLoading || !isAuth) {
            dispatch(setIsShowLoginAndSignInPopup(true));
            // setStorage('showLoginAndSignInPopup', true);
            return;
        }

        setIsLoading(true);
        createOrder(withBonuses)
            .then(response => response.json())
            .then(result => {
                if (result.hash) {
                    navigate(`/m/${result.hash}`);
                    if (result.url) location.href = result.url;
                } else {
                    if (result.message) {
                        alert(result.message);
                        setIsLoading(false);
                    }
                }
                return null;
            });
    }

    useEffect(() => {
        if (cartOffer) {
            setOffer(cartOffer);
            if (cartOffer.cartId) getBonusDiscount(cartOffer.cartId);
        }
    }, [cartOffer]);

    if (!offer) return null;

    const deliveryPrice = offer.delivery.courierPrice;
    const productsCount = () => {
        return offer.products.reduce((p, n) => p + n.amount, 0)
    };
    const scheduleOptions = offer.delivery.time.map(({ from, to }) => {
        const value = `C ${from} до ${to}`;

        return {
            label: value,
            value
        };
    });
    const schedule = scheduleOptions.length ? scheduleOptions[0].value : '';

    return (
        <div className={cn(styles.wrapper, styles.orderSummary)}>
            <h3 className={styles.title}>Ваш заказ</h3>
            <div className={styles.products}>
                <div className={styles.productsTitle}>Выбрано товаров</div>
                <div className={styles.productsCounter}>{productsCount()} шт.</div>
            </div>
            <div className={styles.outline}></div>

            {
                bonusBalance > 0 ?
                    <>
                        <div>
                            <div className={styles.bonuses}>
                                <div>Баланс бонусного счета</div>
                                <div className={styles.bonusesCounter}>{withBonuses ? bonusBalance - bonusDiscount : bonusBalance} ₽</div>
                            </div>
                            <div style={{ marginTop: 12, marginBottom: 12 }}>
                                <div className={styles.bonuses}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                        <Checkbox
                                            checked={withBonuses}
                                            onChange={() => setWithBonuses(!withBonuses)}
                                        />
                                        <div>Использовать бонусы</div>
                                    </div>
                                    <div className={styles.bonusesCounter}>{withBonuses ? 0 : bonusDiscount} ₽</div>
                                </div>
                                <div className={styles.bonusesAdjustmentBlockTip}>
                                    Не более 10% от стоимости заказа
                                </div>
                            </div>
                        </div>
                        <div className={styles.outline}></div>
                    </>
                    : null
            }

            <div className={styles.delivery}>
                <div className={styles.deliveryPayment}>
                    <div className={styles.deliveryPaymentWrapper}>
                        {
                            offer.delivery.type !== DeliveryType.pickup
                                ? <div className={styles.deliveryPaymentPrice}>
                                    <div>
                                        Доставка:
                                    </div>
                                    <div className={styles.deliveryPaymentPriceAmount}>
                                        {`${deliveryPrice} ₽`}
                                    </div>
                                </div>
                                : null
                        }

                        <div className={styles.deliveryPaymentTotalPrice}>
                            <div className={styles.deliveryPaymentTotalPriceTitle}>
                                Итого к оплате
                            </div>
                            <div className={styles.deliveryPaymentTotalPriceAmount}>
                                {withBonuses ? (offer.remainingPaymentAmount - bonusDiscount) : offer.remainingPaymentAmount} ₽
                            </div>
                        </div>
                    </div>

                    <div className={styles.deliveryPaymentMethod}>
                        <div className={styles.deliveryPaymentMethodName}>
                            {offer.paymentMethodName ?? 'Не выбран'}
                        </div>
                        {/*<Button*/}
                        {/*    type='text'*/}
                        {/*    className={styles.deliveryPaymentMethodBtnChange}*/}
                        {/*>*/}
                        {/*    Изменить*/}
                        {/*</Button>*/}
                    </div>
                </div>

                {
                    offer.delivery.type !== DeliveryType.pickup
                        ? <>
                            <div className={styles.outline} />
                            <div className={styles.deliveryInfo}>
                                <div className={styles.deliveryInfoTitle}>
                                    Информация о доставке:
                                </div>
                                {offer.delivery ? (<>
                                    <div className={styles.deliveryType}>{offer.delivery.typeName}</div>
                                    <div className={styles.deliveryAdress}>{offer.delivery.address}</div>
                                    <Button
                                        style={{ marginLeft: 8, }}
                                        type='text'
                                        className={styles.deliveryTypeBtnChange}
                                        onClick={() => setIsOpenChangeTownModal(true)}
                                    >
                                        изменить
                                    </Button>
                                    {
                                        schedule
                                            ? <>
                                                <div className={styles.outline} />
                                                <div className={styles.deliveryDateWrapper}>
                                                    <div>
                                                        Доставим:
                                                    </div>
                                                    <div className={styles.deliveryDate}>
                                                        {schedule}
                                                    </div>
                                                </div>
                                            </>
                                            : null
                                    }
                                </>) : <div className={styles.deliveryInfoNotAvailable}>Отсутствует</div>}
                            </div>
                        </>
                        : null
                }
            </div>
            <Button
                type='regular'
                className={styles.btnOrder}
                id='order-btn'
                onClick={() => receiveCreateOrder()}
            >
                {isLoading ? <><Loader /> Заказ оформляется</> : <>Оформить заказ</>}
            </Button>
            <div className={styles.policy}>
                Нажимая на кнопку оформить заказ вы соглашаетесь с <a href='#'>политикой конфиденциальности</a> и <a href='#'>условиями бонусной программы</a>
            </div>
        </div>
    );
};
